export const formConfig = [
  {
    type: 'dimensionPicker',
    label: 'Afmetingen',
    name: 'DIMENSION',
    detailed_label: 'Wat zijn de gewenste breedte en hoogte voor uw vliegenraam?',
    title: 'Afmetingen',
    validation: {
      WIDTH: { required: 'Breedte is verplicht', min: { value: 500, message: 'Breedte moet minimaal 500mm zijn' }, max: { value: 1500, message: 'Breedte mag minimaal 1500mm zijn' } },
      HEIGHT: { required: 'Hoogte is verplicht', min: { value: 500, message: 'Hoogte moet minimaal 500mm zijn' }, max: { value: 2500, message: 'Hoogte mag minimaal 2500mm zijn' } }
    }

  },

  {
    type: 'yesnoPicker',
    label: 'Opmeting laten uitvoeren',
    name: 'OPMETING',
    detailed_label: <>Ik wens de opmeeting te laten uitvoeren zodat ik zeker ben van de maten <span className="text-blue-600">(Eénmalig +150 euro)</span></>,
    title: 'Controle opmeting',
    validation: { }

  },

  {
    title: "Gaas",
    detailed_label: "Welk type gaas wenst u voor uw vliegenraam",
    name: "GAAS_TYPE",
    label: "Kleur van het gaas",
    type: "shapePicker",
    defaultValue: "SGG",
    options: [
      { label: "Standaard grijs", color: "#000", code: "SGG" },
      { label: "Standaard zwart", color: "#000", code: "SZG" },
      { label: "Vista+", color: "#4e3b31", code: "BG" },
      { label: "Petscreen grijs", color: "#0a0a0b", code: "PGG" },
      { label: "Petscreen zwart", color: "#0a0a0b", code: "PGZ" },
      { label: "Screendoek zwart", color: "#0a0a0f", code: "SDZ" },
      { label: "Screendoek grijs", color: "#0a0a0a", code: "SDG" },
     // { label: "Screendoek beige", color: "#e6e6e6", code: "SDB" },
      { label: "Inox", color: "#f6f6f6", code: "IV" },
    ],
    validation: { required: 'Type gaas is verplicht' }

  },
  {
    title: "Kleur",
    detailed_label: "Welke kleur wenst u voor het kader van uw vliegenraam",
    name: "FRAME_COLOR",
    label: "Kleur van het frame",
    type: "colorPicker",
    defaultValue: "RAL 9016",
    options: [
      { label: "RAL 9016 glanzend (wit)", color: "#f6f6f6", code: "RAL 9016" },
      { label: "RAL 7016 glanzend (antraciet)", color: "#383e42", code: "RAL 7016" },
      { label: "RAL 8019 glanzend (bruin)", color: "#4e3b31", code: "RAL 8019" },
      { label: "RAL 9001 glanzend (crème)", color: "#fdf4e3", code: "RAL 9001" },
      { label: "RAL 9005 structuur (zwart)", color: "#0a0a0a", code: "RAL 9005" },
    ],
    validation: { required: 'Gelieve een kleur van het frame te selecteren' }
  },
  


  ];
  
  